// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file session_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { SyncUpdate, SyncUpdateField } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file session_service.proto.
 */
export const file_session_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_sync_update, file_google_protobuf_wrappers]);

/**
 * @generated from message domain.DeleteSessionRequest
 */
export type DeleteSessionRequest = Message<"domain.DeleteSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message domain.DeleteSessionRequest.
 * Use `create(DeleteSessionRequestSchema)` to create a new message.
 */
export const DeleteSessionRequestSchema: GenMessage<DeleteSessionRequest> = /*@__PURE__*/
  messageDesc(file_session_service, 0);

/**
 * @generated from message domain.DeleteSessionResponse
 */
export type DeleteSessionResponse = Message<"domain.DeleteSessionResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteSessionResponse.
 * Use `create(DeleteSessionResponseSchema)` to create a new message.
 */
export const DeleteSessionResponseSchema: GenMessage<DeleteSessionResponse> = /*@__PURE__*/
  messageDesc(file_session_service, 1);

/**
 * @generated from message domain.CreateSessionUnlockRequest
 */
export type CreateSessionUnlockRequest = Message<"domain.CreateSessionUnlockRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: bytes encrypted_secret = 2;
   */
  encryptedSecret: Uint8Array;

  /**
   * @generated from field: string authenticator_id = 3;
   */
  authenticatorId: string;

  /**
   * @generated from field: google.protobuf.Timestamp max_expires_at = 4;
   */
  maxExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.CreateSessionUnlockRequest.
 * Use `create(CreateSessionUnlockRequestSchema)` to create a new message.
 */
export const CreateSessionUnlockRequestSchema: GenMessage<CreateSessionUnlockRequest> = /*@__PURE__*/
  messageDesc(file_session_service, 2);

/**
 * @generated from message domain.CreateSessionUnlockResponse
 */
export type CreateSessionUnlockResponse = Message<"domain.CreateSessionUnlockResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.CreateSessionUnlockResponse.
 * Use `create(CreateSessionUnlockResponseSchema)` to create a new message.
 */
export const CreateSessionUnlockResponseSchema: GenMessage<CreateSessionUnlockResponse> = /*@__PURE__*/
  messageDesc(file_session_service, 3);

/**
 * @generated from message domain.DeleteSessionUnlockRequest
 */
export type DeleteSessionUnlockRequest = Message<"domain.DeleteSessionUnlockRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: bool only_pending_request = 2;
   */
  onlyPendingRequest: boolean;
};

/**
 * Describes the message domain.DeleteSessionUnlockRequest.
 * Use `create(DeleteSessionUnlockRequestSchema)` to create a new message.
 */
export const DeleteSessionUnlockRequestSchema: GenMessage<DeleteSessionUnlockRequest> = /*@__PURE__*/
  messageDesc(file_session_service, 4);

/**
 * @generated from message domain.DeleteSessionUnlockResponse
 */
export type DeleteSessionUnlockResponse = Message<"domain.DeleteSessionUnlockResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteSessionUnlockResponse.
 * Use `create(DeleteSessionUnlockResponseSchema)` to create a new message.
 */
export const DeleteSessionUnlockResponseSchema: GenMessage<DeleteSessionUnlockResponse> = /*@__PURE__*/
  messageDesc(file_session_service, 5);

/**
 * @generated from message domain.RequestSessionUnlockRequest
 */
export type RequestSessionUnlockRequest = Message<"domain.RequestSessionUnlockRequest"> & {
  /**
   * Identifies the UI component or call site that initiated this unlock.
   * Logged for debugging ghost notifications. Free-form on the wire; the
   * TypeScript chokepoint constrains the values to a UnlockRequestSource union.
   * Empty for legacy clients that predate this field.
   *
   * @generated from field: string source = 1;
   */
  source: string;
};

/**
 * Describes the message domain.RequestSessionUnlockRequest.
 * Use `create(RequestSessionUnlockRequestSchema)` to create a new message.
 */
export const RequestSessionUnlockRequestSchema: GenMessage<RequestSessionUnlockRequest> = /*@__PURE__*/
  messageDesc(file_session_service, 6);

/**
 * @generated from message domain.RequestSessionUnlockResponse
 */
export type RequestSessionUnlockResponse = Message<"domain.RequestSessionUnlockResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RequestSessionUnlockResponse.
 * Use `create(RequestSessionUnlockResponseSchema)` to create a new message.
 */
export const RequestSessionUnlockResponseSchema: GenMessage<RequestSessionUnlockResponse> = /*@__PURE__*/
  messageDesc(file_session_service, 7);

/**
 * @generated from message domain.ExtendSessionUnlockRequest
 */
export type ExtendSessionUnlockRequest = Message<"domain.ExtendSessionUnlockRequest"> & {
  /**
   * session will be extended up to the unlock time limit, based on last user activity
   *
   * @generated from field: google.protobuf.Timestamp last_user_activity = 1;
   */
  lastUserActivity?: Timestamp | undefined;
};

/**
 * Describes the message domain.ExtendSessionUnlockRequest.
 * Use `create(ExtendSessionUnlockRequestSchema)` to create a new message.
 */
export const ExtendSessionUnlockRequestSchema: GenMessage<ExtendSessionUnlockRequest> = /*@__PURE__*/
  messageDesc(file_session_service, 8);

/**
 * @generated from message domain.ExtendSessionUnlockResponse
 */
export type ExtendSessionUnlockResponse = Message<"domain.ExtendSessionUnlockResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.ExtendSessionUnlockResponse.
 * Use `create(ExtendSessionUnlockResponseSchema)` to create a new message.
 */
export const ExtendSessionUnlockResponseSchema: GenMessage<ExtendSessionUnlockResponse> = /*@__PURE__*/
  messageDesc(file_session_service, 9);

/**
 * @generated from message domain.UpdateSessionRequest
 */
export type UpdateSessionRequest = Message<"domain.UpdateSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * list of additional fields to include in the sync update triggered by this request
   *
   * @generated from field: repeated domain.SyncUpdateField fields_to_update = 2;
   */
  fieldsToUpdate: SyncUpdateField[];

  /**
   * @generated from field: google.protobuf.StringValue client_settings = 3;
   */
  clientSettings?: string | undefined;

  /**
   * @generated from field: domain.UpdateSessionRequest.EnabledProfiles enabled_profiles = 4;
   */
  enabledProfiles?: UpdateSessionRequest_EnabledProfiles | undefined;

  /**
   * @generated from field: google.protobuf.UInt32Value unlock_time_limit_minutes = 9;
   */
  unlockTimeLimitMinutes?: number | undefined;

  /**
   * @generated from field: google.protobuf.StringValue fcm_device_token = 6;
   */
  fcmDeviceToken?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue device_info = 7;
   */
  deviceInfo?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue apns_device_token = 8;
   */
  apnsDeviceToken?: string | undefined;
};

/**
 * Describes the message domain.UpdateSessionRequest.
 * Use `create(UpdateSessionRequestSchema)` to create a new message.
 */
export const UpdateSessionRequestSchema: GenMessage<UpdateSessionRequest> = /*@__PURE__*/
  messageDesc(file_session_service, 10);

/**
 * @generated from message domain.UpdateSessionRequest.EnabledProfiles
 */
export type UpdateSessionRequest_EnabledProfiles = Message<"domain.UpdateSessionRequest.EnabledProfiles"> & {
  /**
   * if empty, all profiles are enabled.
   * if all profiles are listed, this value will be normalized to empty
   * non existent profiles will be filtered out
   *
   * @generated from field: repeated string profile_ids = 1;
   */
  profileIds: string[];
};

/**
 * Describes the message domain.UpdateSessionRequest.EnabledProfiles.
 * Use `create(UpdateSessionRequest_EnabledProfilesSchema)` to create a new message.
 */
export const UpdateSessionRequest_EnabledProfilesSchema: GenMessage<UpdateSessionRequest_EnabledProfiles> = /*@__PURE__*/
  messageDesc(file_session_service, 10, 0);

/**
 * @generated from message domain.UpdateSessionResponse
 */
export type UpdateSessionResponse = Message<"domain.UpdateSessionResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateSessionResponse.
 * Use `create(UpdateSessionResponseSchema)` to create a new message.
 */
export const UpdateSessionResponseSchema: GenMessage<UpdateSessionResponse> = /*@__PURE__*/
  messageDesc(file_session_service, 11);

/**
 * SessionService provides methods for session management.
 * (1) Client calls ListSessions to get a list of the users open sessions.
 * (2) Client calls DeleteSession to remove a session from the server.
 *     The client with the corresponding token can no longer access the server
 *     and must log in again
 *
 * @generated from service domain.SessionService
 */
export const SessionService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - SessionNotFound (20410): session_id not in database
   * - PermissionDenied (10100) : session does not belong to user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SessionService.DeleteSession
   */
  deleteSession: {
    methodKind: "unary";
    input: typeof DeleteSessionRequestSchema;
    output: typeof DeleteSessionResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - InvalidTimeout (20420): expires_at ist already expired
   * - AuthenticatorNotFound (40400): authenticator does not belong to user
   * - NotAllowedForAuthenticator (40480)
   * - SessionNotFound (20410): session does not belong to user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SessionService.CreateSessionUnlock
   */
  createSessionUnlock: {
    methodKind: "unary";
    input: typeof CreateSessionUnlockRequestSchema;
    output: typeof CreateSessionUnlockResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - SessionNotFound (20410): session not in database or does not belong to user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SessionService.DeleteSessionUnlock
   */
  deleteSessionUnlock: {
    methodKind: "unary";
    input: typeof DeleteSessionUnlockRequestSchema;
    output: typeof DeleteSessionUnlockResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - SessionNotFound (20410): session not in database or does not belong to user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SessionService.RequestSessionUnlock
   */
  requestSessionUnlock: {
    methodKind: "unary";
    input: typeof RequestSessionUnlockRequestSchema;
    output: typeof RequestSessionUnlockResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - SessionNotFound (20410)
   * - SessionNotUnlocked (20431)
   * - Internal (10500)
   *
   * @generated from rpc domain.SessionService.ExtendSessionUnlock
   */
  extendSessionUnlock: {
    methodKind: "unary";
    input: typeof ExtendSessionUnlockRequestSchema;
    output: typeof ExtendSessionUnlockResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - SessionNotFound (20410): session not in database or does not belong to user
   * - MalformedClientSettings (20480): the client settings are not valid JSON
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SessionService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateSessionRequestSchema;
    output: typeof UpdateSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_session_service, 0);

